import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.d5g().a50() : headers;
  return DelegatedCall().x5h(_this__u8e3s4.y5f_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static x5h(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.d5g().a50() : responseHeaders;
        var $this = this.y5h(client);
        $this.a5g_1 = new (DelegatedRequest())($this, originCall.z5h());
        $this.b5g_1 = new (DelegatedResponse())($this, originCall.d5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.e5i_1 = origin;
        this.f5i_1 = call;
      }
      g5i() {
        return this.f5i_1;
      }
      ew() {
        return this.e5i_1.ew();
      }
      h5i() {
        return this.e5i_1.h5i();
      }
      i5i() {
        return this.e5i_1.i5i();
      }
      a5i() {
        return this.e5i_1.a5i();
      }
      i2o() {
        return this.e5i_1.i2o();
      }
      a50() {
        return this.e5i_1.a50();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.a50() : headers;
        super();
        this.j5i_1 = call;
        this.k5i_1 = origin;
        this.l5i_1 = content;
        this.m5i_1 = headers;
        this.n5i_1 = this.k5i_1.ew();
      }
      g5i() {
        return this.j5i_1;
      }
      a50() {
        return this.m5i_1;
      }
      o5i() {
        return this.l5i_1(this.k5i_1);
      }
      ew() {
        return this.n5i_1;
      }
      p5i() {
        return this.k5i_1.p5i();
      }
      q5i() {
        return this.k5i_1.q5i();
      }
      r5i() {
        return this.k5i_1.r5i();
      }
      s5i() {
        return this.k5i_1.s5i();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
